<template>
        <div class="m-portlet m-portlet--head-sm" v-loading="loading" v-if="powers.includes(53)">
            <div class="m-portlet__head" >
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <div class="m-portlet__head-text">
                            <div>
                                <el-row :gutter="30">
                                    <el-col :span="3">
                                        <el-select v-model="filter.section_id" placeholder="请选择校区" @change="handleShow()" style="width: 100px">
                                            <el-option
                                                    v-for="item in sections"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="4">
                                        <el-select v-model="filter.grade_id" multiple placeholder="请选择年级" @change="changeGrade">
                                                <el-option
                                                        v-for="item in grades"
                                                        :key="item.id"
                                                        :label="item.name"
                                                        :value="item.id">
                                                </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="7">
                                        <small>日期：</small>
                                        <el-date-picker
                                                v-model="filter.date"
                                                type="date"
                                                :clearable="false"
                                                value-format="yyyy-MM-dd"
                                                placeholder="选择日期"
                                                @change="handleShow()">
                                        </el-date-picker>
                                    </el-col>
                                    <el-col :span="2">
                                            <el-switch style="padding:0 20px" v-model="showStudent"
                                                       @change="showStudentFuc"
                                                       active-text="显示学生"
                                                       size="small">
                                            </el-switch>
                                    </el-col>
                                    <el-col :span="2">
                                        <el-button @click="handleTableSite()" v-if="powers.includes(150)">设置</el-button>
                                    </el-col>

                                    <el-col :span="3">
                                        <el-dropdown trigger="click" size="medium">
                                            <el-button > 筛选</el-button>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item @click.native="handleFreeClassroom()">空余教室</el-dropdown-item>
                                                <el-dropdown-item @click.native="handleChooseStudent()">学生</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </el-col>
                                    <el-col :span="2">
                                        <el-button @click="download()" v-if="powers.includes(128)">导出excel</el-button>
                                    </el-col>
                                </el-row>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body"  v-if="V4Judge">

                <DailyTable ref="V4Table"
                            @handleMouseDown="handleMousedown"
                            @drop="drop"
                            @allowDrop="allowDrop"
                            @handleCellClick="handleCellClick"
                            v-show="V4Show"> </DailyTable>
            </div>
        </div>
</template>

<script>
    import index from './Index';
    import store from '@/store'
    export default {
        name: "OperationDaily",
        data() {
            return {
                path:"/timeTable/day",
                loading:true,
                V4Judge:false,
                V4Show:false,
                showStudent:false,

                //subscribe
                grades:{},
                sections:{},
                classes:{},
                timeData: {},
                basisTime:{},
                subjects:{},
                teachers:{},
                class_student:{},
                currentUsers: {},
                date:'',
                tempLength:0,

                classrooms:{},
                scroll: {
                    left: 0,
                    top: 0
                },
                filter:{
                    section_id:this.$store.state.config.section.id,
                    grade_id: [],
                    date:this.$moment().format('YYYY-MM-DD')
                },
                classx:'',
                classForm: {},

                //每日课表组件
                ops: {
                    rail: {
                        size: '3px',
                        gutterOfSide: '5px'
                    },
                    bar: {
                        keepShow: true,
                        background: 'rgba(144, 147, 153, 0.3)'
                    }
                },
                ctx: '',
                timeCtx: '',
                V4cell: {
                    selectable: false,
                    subject_id:'',
                    teacher_id:'',
                    startSort:0,
                },
                content:'',
                scrollLeft: 0,
                scrollTop: 0,
                startTime:8,
                type:'dayTimeTable',
                swapDate:{
                    button_loading:false
                },
                Dialog_ClassPlanInformation:{
                    classPlan_teacherVisits:{},
                    classPlan_teacherVisit_content:'',
                    classPlan_interactives:{},
                    classPlan_notices:{},
                    classPlan_notice_content:'',
                    classPlan_assessments:{},
                    classPlan_id:'',
                    loading:false,
                },
                Dialog_UpdateClass:{
                    button_loading:false
                },
                Dialog_GoToStudent:{
                    student_phone:'',
                    parents:'',
                },
                Dialog_ChooseFreeClassroom:{
                    classroom:[],
                    classroom_names:[],
                    classroom_nums:[],
                    loading:false,
                },
                Dialog_ChooseStudent:{
                    choose_students:[],
                    students:[],
                    currentPage: 1,
                    currentPageSize: 10,
                    total:0,
                    loading:false,
                    classPlan_status:[],
                }
            }
        },
        components: {
            'DailyTable': index,
        },
        created() {
            this.$wApi.addListen(this.path,this.handleData);
            this.handleShow()
        },
        beforeDestroy(){
            this.$wApi.removeListen(this.path)
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            }
        },
        methods: {
            handleData(event,data){
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'show':
                        this.sections = data.sections;
                        this.grades = data.grades;
                        this.timeData = data.timeData;
                        this.subjects = data.subjects;
                        this.teachers = data.teachers;
                        this.classes = data.classes;
                        this.basisTime= data.basisTime;
                        this.classrooms = data.classrooms;
                        this.class_student = data.class_student;
                        this.filter.date=data.filter.date;
                        this.tempLength = data.tempLength;
                        this.V4Show=true;
                        this.loading = false;
                        this.V4Judge=true;
                        setTimeout(()=>{
                            if(this.V4Judge){
                                this.$refs.V4Table.initCanvas()
                            }
                        },100)
                        break;
                    case 'class_update':
                        if (data.type == 'cache') {
                            this.$refs.V4Table.cacheData = {
                                rect: [],
                                subject_id: '',
                                teacher_id: '',
                                classPlan_id: '',
                                class_name: '',
                                class_id: '',
                                classHeight: 1,
                                classroom_name: '',
                                classroom_id: '',
                                remark: '',
                                selectable: false,
                                draggable: false,
                                chooseOn: false,
                            };
                        }
                        if(this.filter.date==data.old_date){
                            if(this.classes[data.old_teacher_id]){
                                for(let key in this.classes[data.old_teacher_id]){
                                    if(this.classes[data.old_teacher_id][key].class_plan_id==data.classPlan_id){
                                        this.classes[data.old_teacher_id].splice(key,1)
                                        this.$refs.V4Table.initCanvas()
                                        break;
                                    }
                                }
                            }
                        }
                        if(this.filter.date==data.classPlan.date){
                            if(this.classes[data.classPlan.teacher_id]){
                                this.classes[data.classPlan.teacher_id].push(data.classPlan);

                            }else{
                                this.classes[data.classPlan.teacher_id]=[data.classPlan]
                            }
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.$refs.V4Table.initCanvas()
                        }
                        this.$refs.V4Table.paintCache()
                        this.$Win.closeModal();
                        break;
                    case 'class_update_error':
                        this.$refs.V4Table.initCanvas()
                        this.$refs.V4Table.paintCache()
                        break;
                    case 'drop_class':
                       for (let key in data.old_timeTable ) {
                           if(this.filter.date==data.old_timeTable[key].date && this.filter.section_id==data.old_timeTable[key].section_id){
                               if(this.classes[data.old_timeTable[key].teacher_id]){
                                   for(let key1 in this.classes[data.old_timeTable[key].teacher_id]){
                                       if(this.classes[data.old_timeTable[key].teacher_id][key1].class_plan_id==data.old_timeTable[key].class_plan_id){
                                           this.classes[data.old_timeTable[key].teacher_id].splice(key1,1)
                                           break;
                                       }
                                   }
                               }
                           }
                       }
                        for (let key2 in data.new_timeTable ) {
                            if (this.filter.date ==data.new_timeTable[key2].date && this.filter.section_id ==data.new_timeTable[key2].section_id) {
                                if (this.classes[data.new_timeTable[key2].teacher_id]) {
                                    this.classes[data.new_timeTable[key2].teacher_id].push(data.new_timeTable[key2]);
                                } else {
                                    this.classes[data.new_timeTable[key2].teacher_id] = [data.new_timeTable[key2]]
                                }

                            }
                        }
                        this.$refs.V4Table.initCanvas()
                        this.$refs.V4Table.paintCache()
                        break;
                    case 'create_class':
                        for (let key in data.timeTable_days ) {
                            if (this.filter.date ==data.timeTable_days[key].date && this.filter.section_id ==data.timeTable_days[key].section_id) {
                                if (this.classes[data.timeTable_days[key].teacher_id]) {
                                    this.classes[data.timeTable_days[key].teacher_id].push(data.timeTable_days[key]);
                                } else {
                                    this.classes[data.timeTable_days[key].teacher_id] = [data.timeTable_days[key]]
                                }
                            }
                        }
                        this.$refs.V4Table.initCanvas()
                        this.$refs.V4Table.paintCache()
                    break;
                    case 'swap_date':
                        if(data.first_date==this.filter.date && this.filter.section_id ==data.section_id){
                            this.classes=data.first_date_timeTable;
                        }

                        if(data.swap_date==this.filter.date && this.filter.section_id ==data.section_id){
                            this.classes=data.swap_date_timeTable;
                        }
                        this.$refs.V4Table.initCanvas()
                        this.$refs.V4Table.paintCache()
                        break;
                    case 'swap_date_success':
                        this.swapDate.button_loading=false;
                        this.$message({
                            message: '互换成功',
                            type: 'success'
                        });
                        break;
                    case 'swap_date_error':
                        this.swapDate.button_loading=false;
                        break;
                    case 'get_classPlanInformation':
                        if (Object.keys(data.classPlan_teacherVisits).length !== 0) {
                            this.Dialog_ClassPlanInformation.classPlan_teacherVisits = data.classPlan_teacherVisits
                        } else {
                            this.Dialog_ClassPlanInformation.classPlan_teacherVisits = new Object();
                        }

                        if (Object.keys(data.classPlan_interactives).length !== 0) {
                            this.Dialog_ClassPlanInformation.classPlan_interactives = data.classPlan_interactives
                        } else {
                            this.Dialog_ClassPlanInformation.classPlan_interactives = new Object();
                        }

                        if (Object.keys(data.classPlan_notices).length !== 0) {
                            this.Dialog_ClassPlanInformation.classPlan_notices = data.classPlan_notices
                        } else {
                            this.Dialog_ClassPlanInformation.classPlan_notices = new Object();
                        }

                        if (Object.keys(data.classPlan_assessments).length !== 0) {
                            this.Dialog_ClassPlanInformation.classPlan_assessments = data.classPlan_assessments
                        } else {
                            this.Dialog_ClassPlanInformation.classPlan_assessments = new Object();
                        }
                        this.Dialog_ClassPlanInformation.loading=false
                        break;
                    case 'get_classPlanInformation_error':
                        this.Dialog_ClassPlanInformation.loading=false
                        break;
                    case 'store_classPlanTeacherVisit':
                        this.$set(this.Dialog_ClassPlanInformation.classPlan_teacherVisits,data.classPlan_teacherVisit.id,data.classPlan_teacherVisit)
                        this.Dialog_ClassPlanInformation.classPlan_teacherVisit_content='';
                        this.$message({
                            message: '创建成功',
                            type: 'success'
                        });
                        break;
                    case 'sending_classPlanInteractive':
                        this.Dialog_ClassPlanInformation.classPlan_interactives[data.classPlanInteractive_id].isSending=1;
                        this.$message({
                            message: '发送成功',
                            type: 'success'
                        });
                        break;
                    case 'sending_classPlanNotice':
                        this.Dialog_ClassPlanInformation.classPlan_notices[data.classPlanNotice_id].isSending=1;
                        this.$message({
                            message: '发送成功',
                            type: 'success'
                        });
                        break;
                    case 'store_classPlanNotice':
                        this.$set(this.Dialog_ClassPlanInformation.classPlan_notices,data.classPlan_notice.id,data.classPlan_notice)
                        this.$message({
                            message: '创建成功',
                            type: 'success'
                        });
                        this.Dialog_ClassPlanInformation.classPlan_notice_content='';
                        break;
                    case 'get_other_classPlanInformation':
                        store.commit('titleChange',
                            {

                                'title':data.title,
                            });
                        this.Dialog_ClassPlanInformation.classPlan_id=data.new_classPlan_id;
                        if (Object.keys(data.classPlan_teacherVisits).length !== 0) {
                            this.Dialog_ClassPlanInformation.classPlan_teacherVisits = data.classPlan_teacherVisits
                        } else {
                            this.Dialog_ClassPlanInformation.classPlan_teacherVisits = new Object();
                        }

                        if (Object.keys(data.classPlan_interactives).length !== 0) {
                            this.Dialog_ClassPlanInformation.classPlan_interactives = data.classPlan_interactives
                        } else {
                            this.Dialog_ClassPlanInformation.classPlan_interactives = new Object();
                        }

                        if (Object.keys(data.classPlan_notices).length !== 0) {
                            this.Dialog_ClassPlanInformation.classPlan_notices = data.classPlan_notices
                        } else {
                            this.Dialog_ClassPlanInformation.classPlan_notices = new Object();
                        }

                        if (Object.keys(data.classPlan_assessments).length !== 0) {
                            this.Dialog_ClassPlanInformation.classPlan_assessments = data.classPlan_assessments
                        } else {
                            this.Dialog_ClassPlanInformation.classPlan_assessments = new Object();
                        }
                        this.Dialog_ClassPlanInformation.loading=false
                        break;
                    case 'get_other_classPlanInformation_error':
                        this.Dialog_ClassPlanInformation.loading=false
                        break;
                    case 'student_signLog':
                        this.$set(this.class_student,data.classPlan_id,data.classPlan_student)
                        this.$refs.V4Table.initCanvas()
                        this.$refs.V4Table.paintCache()
                        break;
                    case 'store_specialClass':
                        if (this.filter.date == data.classPlan.date) {
                            if (this.classes[data.classPlan.teacher_id]) {
                                this.classes[data.classPlan.teacher_id].push(data.classPlan);
                            } else {
                                this.classes[data.classPlan.teacher_id] = [data.classPlan]
                            }
                            this.V4cell.selectable = true;
                            this.$refs.V4Table.initCanvas()
                            this.$refs.V4Table.paintCache()
                        }
                        this.dialogVisible=false;
                        this.$refs['V4Table'].cell.visible = false;
                        break;
                    case 'classPlan_delete':
                        if (this.filter.date == data.date){
                            if (this.classes[data.teacher_id]) {
                                let teacher_classes=this.classes[data.teacher_id];
                                teacher_classes.forEach(function(item, index, arr) {
                                    if(item.class_plan_id == data.classPlan_id) {
                                        arr.splice(index, 1);
                                    }
                                });
                            }
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });

                        }
                        this.Dialog_UpdateClass.button_loading=false
                        this.V4cell.selectable = true;
                        this.$refs.V4Table.initCanvas()
                        this.$refs.V4Table.paintCache()
                        this.$Win.closeModal();
                        break;
                    case 'get_student_phone':
                        this.Dialog_GoToStudent.student_phone=data.student_phone;
                        this.Dialog_GoToStudent.parents=data.student_parents;
                        break;
                    case 'choose_empty_classroom':
                        this.Dialog_ChooseFreeClassroom.classrooms=data.classrooms;
                        this.Dialog_ChooseFreeClassroom.loading=false
                        break;
                    case 'get_classroom_fields':
                        this.Dialog_ChooseFreeClassroom.classroom_names=data.classroom_names;
                        this.Dialog_ChooseFreeClassroom.classroom_nums=data.classroom_nums;
                        break;
                    case 'choose_student':
                        this.Dialog_ChooseStudent.choose_students=data.choose_students;
                        if (Object.keys(data.classPlan_status).length !== 0) {
                            this.Dialog_ChooseStudent.classPlan_status = data.classPlan_status
                        } else {
                            this.Dialog_ChooseStudent.classPlan_status = new Object();
                        }
                        break;
                    case 'get_dailyTable_student':
                        this.Dialog_ChooseStudent.students=data.students;
                        this.Dialog_ChooseStudent.total=data.total;
                        break;
                }
            },
            handleShow(){
                this.loading = true;
                this.$wApi.send(this.path,'show',{'date':this.filter.date,'section_id':this.filter.section_id});
                this.V4Show = false;
            },
            changeGrade(){
                for(let subject_id in this.teachers){
                    for (let key in this.teachers[subject_id]) {
                        var teacherGrades=this.teachers[subject_id][key].grades
                        let union = teacherGrades.filter(v => this.filter.grade_id.includes(v))
                        if(union.length==0 && this.filter.grade_id.length>0){
                            this.teachers[subject_id][key].view=false;
                        }else{
                            this.teachers[subject_id][key].view=true;
                        }
                    }
                }
                var start=0;
                this.tempLength=0;
                for(let key1 in this.subjects){

                    let teacherView=0;
                    for (let teacher_id in this.teachers[key1]) {
                        if(this.teachers[key1][teacher_id].view){
                            teacherView+=1;
                        }
                    }

                    if(teacherView==0 &&  this.filter.grade_id.length==0){
                        teacherView=1;
                    }

                    this.subjects[key1].dataLength=teacherView
                    this.subjects[key1].rect=[this.tempLength+start*0.1,0,teacherView,1]
                    this.tempLength+=teacherView;
                    if(teacherView==0){
                        this.subjects[key1].view=false;
                    }else{
                        this.subjects[key1].view=true;
                        start=start+1;
                    }
                }
                setTimeout(()=>{
                    this.$refs.V4Table.initCanvas();
                },100)
            },
            //点击
            handleCellClick() {
                if(this.V4cell.selectable){
                    if(this.classes[this.V4cell.teacher_id]){
                        for(var key in this.classes[this.V4cell.teacher_id]){
                            if(this.classes[this.V4cell.teacher_id][key].start_sort-this.startTime==this.V4cell.startSort){
                                if(this.classes[this.V4cell.teacher_id][key].section_id==this.filter.section_id){
                                    let clickJudge=true;
                                    if(this.filter.section_id==4){
                                        if(!this.powers.includes(144)){
                                            clickJudge=false;
                                        }
                                    }
                                    if(clickJudge){
                                        this.$Win.openModal('Dialog_UpdateClass', 550, 700, '修改课程',
                                            {'class_plan_id':this.classes[this.V4cell.teacher_id][key].class_plan_id,
                                                'class_id':this.classes[this.V4cell.teacher_id][key].class_id});
                                    }
                                }else{
                                    return this.$message({
                                        message: '校区不同',
                                        type: 'warning'
                                    });
                                }

                            }
                        }
                    }
                }
            },
            handleMousedown(evt) {
                if (evt.type == 'class') {
                    this.V4cell.subject_id=evt.subject_id;
                    this.V4cell.teacher_id=evt.teacher_id;
                    this.V4cell.startSort=evt.startSort;
                    this.V4cell.selectable=true;

                }else{
                    this.V4cell.subject_id='';
                    this.V4cell.teacher_id='';
                    this.V4cell.startSort=0;
                    this.V4cell.selectable=false;

                }
            },
            handleCanvaClick($event){
                this.cacheData.selectable=true;
            },
            drop: function (evt) {
                this.$wApi.send(this.path,'class_update',{
                    'classPlan_id':evt.origin.classPlan_id,
                    'teacher_id': evt.next.teacher_id,
                    'type': evt.origin.type,
                    'date': this.filter.date,
                    'time': evt.next.time,
                    'duration':evt.origin.classHeight,
                    'classroom_id':evt.origin.classroom_id,
                    'remark':evt.origin.remark,
                });
            },
            allowDrop: function (event) {
                event.preventDefault();
                return true;
            },
            showStudentFuc() {
                //this.showStudent = this.showStudent ? false : true;
                this.$refs.V4Table.dropCell.dropClick=false
                if (this.showStudent) {
                    this.$refs['V4Table'].V4rectH = 200 * window.devicePixelRatio;
                    this.$refs['V4Table'].V4divi = 8;

                } else {
                    this.$refs['V4Table'].V4rectH = 50 * window.devicePixelRatio;
                    this.$refs['V4Table'].V4divi = 2;

                }
                this.$nextTick(function () {
                    this.$refs['V4Table'].cell.visible=false;
                    this.$refs.V4Table.initCanvas()
                })
            },
            handleExcel(){
            },
            handleTableSite() {
                let clickJudge=true;
                if(this.filter.section_id==4){
                    if(!this.powers.includes(144)){
                        clickJudge=false;
                    }
                }
                if(clickJudge){
                    this.$Win.openModal('Dialog_DailyTableSiteModal', 441, 100, '课表设置',{});
                }else{
                    this.$message({
                        type: 'warning',
                        message: '无权操作'
                    });
                }
            },
            handleFreeClassroom(){
                this.$Win.openModal('Dialog_ChooseFreeClassroom', 600, 100, '筛选空余教室',{});
            },
            handleChooseStudent(){
                this.$Win.openModal('Dialog_ChooseStudent', 800, 700, '筛选学生',{});
            },
            download(){
                let canvas = document.createElement('canvas');
                canvas.width = ((this.$refs['V4Table'].V4leftTimeW + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio) + ((((this.tempLength + 1) * this.$refs['V4Table'].V4rectW) + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio)
                canvas.height = ((this.$refs['V4Table'].row * this.$refs['V4Table'].V4rectH + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio) + ((2 * this.$refs['V4Table'].V4titleH) / this.$refs['V4Table'].V4ratio)
                var ctx = canvas.getContext("2d");

                ctx.drawImage(this.$refs['V4Table'].timecanvas, 0, (2 * this.$refs['V4Table'].V4titleH) / this.$refs['V4Table'].V4ratio, (this.$refs['V4Table'].V4leftTimeW + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio,
                    (this.$refs['V4Table'].row * this.$refs['V4Table'].V4rectH + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio);

                ctx.drawImage(this.$refs['V4Table'].teachercanvas, (this.$refs['V4Table'].V4leftTimeW + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio, 0, (((this.tempLength + 1) * this.$refs['V4Table'].V4rectW) + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio,
                    (2 * this.$refs['V4Table'].V4titleH) / this.$refs['V4Table'].V4ratio);

                ctx.drawImage(this.$refs['V4Table'].auxiliaryCanvas, (this.$refs['V4Table'].V4leftTimeW + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio, (2 * this.$refs['V4Table'].V4titleH) / this.$refs['V4Table'].V4ratio,
                    (((this.tempLength + 1) * this.$refs['V4Table'].V4rectW) + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio, (this.$refs['V4Table'].row * this.$refs['V4Table'].V4rectH + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio);

                ctx.drawImage(this.$refs['V4Table'].canvas, (this.$refs['V4Table'].V4leftTimeW + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio, (2 * this.$refs['V4Table'].V4titleH) / this.$refs['V4Table'].V4ratio,
                    (((this.tempLength + 1) * this.$refs['V4Table'].V4rectW) + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio, (this.$refs['V4Table'].row * this.$refs['V4Table'].V4rectH + this.$refs['V4Table'].V4ratio * 2) / this.$refs['V4Table'].V4ratio);

                const fileName = `${this.filter.date}课表`;
                canvas.toBlob(function (blob) {
                    const eleLink = document.createElement('a');
                    eleLink.download = fileName;
                    eleLink.style.display = 'none';
                    // 字符内容转变成blob地址
                    eleLink.href = URL.createObjectURL(blob);
                    // 触发点击
                    document.body.appendChild(eleLink);
                    eleLink.click();
                    // 然后移除
                    document.body.removeChild(eleLink);
                },'image/png',1);

            }

        }
    }
</script>

<style scoped>
    .scell {
        display: table;
        position: absolute;
        background: transparent;
        color: #555;
        width: 100px;
        border: 2px solid rgb(141, 193, 245);
        border-radius: 2px;
    }

    .dragging {
        cursor: pointer !important;
    }
</style>
